import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { tokens } from 'styling/tokens'
import { GLWidget } from './GLWidget'

const META = [
  { status: 1, label: 'Free', color: tokens.status.success.fg },
  { status: 2, label: 'Busy', color: tokens.accent.base },
  { status: 3, label: 'Broken', color: tokens.status.danger.fg },
  { status: 4, label: 'Maintenance', color: tokens.status.info.fg },
  { status: 5, label: 'Paused', color: tokens.status.warning.fg },
]

export const GLMachinesWidget = ({
  selectedStatus,
  handleWidget,
}: {
  selectedStatus: number
  handleWidget: (open: boolean, type: number) => void
}) => {
  const { machinery } = useSelector((state: RootState) => state.dashboard)

  const findStatusCount = (status: number) =>
    machinery?.machineStatuses.find((s) => s.status == status)?.count || 0
  const total = machinery?.totalCount || 0
  const pct = (curr: number) => (total ? Math.round((curr / total) * 100) : 0)

  const rows = META.map((m) => {
    const value = findStatusCount(m.status)
    return {
      key: m.status,
      label: m.label,
      value,
      pct: pct(value),
      color: m.color,
      selected: selectedStatus == m.status,
      onClick: () => handleWidget(true, m.status),
    }
  })

  return <GLWidget title='Machines' onViewAll={() => handleWidget(true, null)} rows={rows} />
}
